const LOCALIZED_COMPONENTS = new Set([
  'products',
  'facets',
  'suggestions',
  'catSuggestions',
  'history',
  'pills',
  'sort',
  'filtersButton',
  'popularQueries',
  'didYouMean',
  'pagination',
]);

const LOCALIZED_PROPERTIES = new Set([
  'products.maxItems',
  'products.productsInRow',
  'products.cardType',
  'products.cardTemplateMode',
  'products.customCardTemplate',
  'products.showPrice',
  'products.showImage',
  'facets.limitFacets',
  'facets.maxColors',
  'facets.facetAnimationSpeed',
  'facets.collapseDefault',
  'facets.collapseKeepOpened',
  'facets.collapseIgnore',
  'suggestions.maxItems',
  'catSuggestions.maxItems',
  'history.maxItems',
  'pills.maxItems',
  'sort.options',
  'pagination.type',
  'pagination.maxVisiblePages',
]);

const LOCALIZED_PROPERTY_HELP = new Set([
  'products.cardType',
  'products.cardTemplateMode',
  'products.customCardTemplate',
  'facets.collapseIgnore',
]);

const LOCALIZED_OPTIONS = new Set([
  'cardType.standard',
  'cardType.simple',
  'cardType.horizontal',
  'cardTemplateMode.preset',
  'cardTemplateMode.custom',
  'type.numbers',
  'type.infinite',
  'type.loadMore',
  'options.relevance',
  'options.priceup',
  'options.price_asc',
  'options.pricedown',
  'options.price_desc',
  'options.abcup',
  'options.name_asc',
  'options.abcdown',
  'options.name_desc',
  'options.saledown',
  'options.sale_desc',
  'options.newest',
  'options.date_desc',
]);

export const getEditorComponentTitle = (t, type, fallback) => (
  LOCALIZED_COMPONENTS.has(type)
    ? t(`search.editor.component.${type}.title`)
    : fallback
);

export const getEditorComponentDescription = (t, type, fallback = '') => (
  LOCALIZED_COMPONENTS.has(type)
    ? t(`search.editor.component.${type}.description`)
    : fallback
);

export const getEditorPropertyLabel = (t, componentType, propertyKey, fallback) => {
  const key = `${componentType}.${propertyKey}`;
  return LOCALIZED_PROPERTIES.has(key)
    ? t(`search.editor.property.${key}.label`)
    : fallback;
};

export const getEditorPropertyHelp = (t, componentType, propertyKey) => {
  const key = `${componentType}.${propertyKey}`;
  return LOCALIZED_PROPERTY_HELP.has(key)
    ? t(`search.editor.property.${key}.help`)
    : '';
};

export const getEditorOptionLabel = (t, propertyKey, value) => {
  const key = `${propertyKey}.${value}`;
  return LOCALIZED_OPTIONS.has(key)
    ? t(`search.editor.option.${key}`)
    : String(value);
};
